import * as Yup from 'yup';
import { validateCPF } from 'services/utils/validate_cpf';

export const validationSchema = Yup.object().shape({
  beneficiaries: Yup.string().required('Campo obrigatório'),
  ataUuid: Yup.string().nullable().required('Campo obrigatório'),
  parceria: Yup.string().required('Campo obrigatório'),
  beneficiariosParceria: Yup.string().when('parceria', {
    is: 'Sim',
    then: (schema) => schema.required('Campo obrigatório'),
    otherwise: (schema) => schema,
  }),
  instituicoes: Yup.array().when('parceria', {
    is: 'Sim',
    then: (schema) => schema.min(1, 'Selecione pelo menos uma instituição'),
    otherwise: (schema) => schema,
  }),
  outraInstituicao: Yup.string().when(['parceria', 'instituicoes'], {
    is: (parceria: string, instituicoes: string[]) =>
      parceria === 'Sim' && instituicoes?.includes('privadas'),
    then: (schema) => schema.required('Campo obrigatório'),
    otherwise: (schema) => schema,
  }),
});

export const beneficiaryValidationSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  cpf: Yup.string()
    .required('Preencha esse campo corretamente, com um dado válido.')
    .test('cpf-valid', 'CPF inválido', (value) => validateCPF(value ?? '')),
  telefone: Yup.string()
    .required('Campo obrigatório')
    .matches(/^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/, 'Telefone inválido'),
  unidadeFamiliar: Yup.string().required('Campo obrigatório'),
  comunidade: Yup.string().required('Campo obrigatório'),
  tipoAtividade: Yup.string().required('Campo obrigatório'),
  atividades: Yup.array().min(1, 'Selecione pelo menos uma atividade'),
  extensionistaNome: Yup.string().required('Campo obrigatório'),
  extensionistaPerfil: Yup.string().required('Campo obrigatório'),
  extensionistaRegistro: Yup.string().required('Campo obrigatório'),
});

export default validationSchema;
